module.exports = __webpack_public_path__ + "img/CRT_Spear-005.92e347d3.png";